import { render } from "./PhotoCarouselContent.vue?vue&type=template&id=46541b20"
import script from "./PhotoCarouselContent.vue?vue&type=script&lang=ts"
export * from "./PhotoCarouselContent.vue?vue&type=script&lang=ts"

import "./PhotoCarouselContent.vue?vue&type=style&index=0&id=46541b20&lang=postcss"
script.render = render

export default script